import { Button } from 'antd';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CalendarDTO } from 'entities/calendar';
import { pathKeys } from 'shared/lib/react-router';
import styles from './EmptyCalendarsList.module.scss';

const EmptyCalendarsList: React.FC<{ calendarId: CalendarDTO['id'] }> = ({ calendarId }) => {
  const { t } = useTranslation('Calendar');

  const navigate = useNavigate();
  return (
    <div className={styles.emptyList}>
      <div className={styles.emptyText}>{t('calendarsTable.emptyEventsList.title')}</div>
      <Button
        type="text"
        className={styles.editBtn}
        onClick={() => navigate(pathKeys.calendars.calendarLayout({ calendarId }))}
      >
        {t('calendarsTable.emptyEventsList.editCalendarBtn.text')}
      </Button>
    </div>
  );
};

export { EmptyCalendarsList };
